<ng-container>
	<div *ngIf="showMessage" class="p-2 mt-4 flex flex-col gap-3">
		<p class="break-words">{{ message }}</p>

		<ui-button
			*ngIf="link"
			preset="HIGH_EMPHASIS"
			(click)="openExternalLink()"
			[label]="label"
			icon="external-link"
		></ui-button>

		<div *ngIf="email || fax" class="flex flex-col gap-2">
			<div class="flex flex-col gap-3">
				<ng-container
					*ngIf="email"
					[ngTemplateOutlet]="template"
					[ngTemplateOutletContext]="{
						email: email,
						label: 'Email',
						isOnlyOfType: true,
					}"
				></ng-container>
				<ng-container
					*ngIf="fax"
					[ngTemplateOutlet]="template"
					[ngTemplateOutletContext]="{
						fax: fax,
						label: 'Fax',
						isOnlyOfType: true,
					}"
				>
				</ng-container>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #template let-label="label" let-email="email" let-fax="fax">
	<div class="flex items-center gap-2">
		<div *ngIf="email" class="flex items-center gap-2">
			<app-icon [icon]="ICON.EMAIL"></app-icon>
			<span class="hover:text-green hover:underline break-all text-sm">
				<a
					emailLinkInterceptor
					class="cursor-pointer"
					href="mailto:{{ email }}?subject={{ emailSubject$ | async }}"
					target="_blank"
				>
					{{ email }}
				</a>
			</span>
		</div>

		<div *ngIf="fax" class="flex items-center gap-2">
			<app-icon [icon]="ICON.FAX"></app-icon>
			<span class="break-all text-sm">
				<p>
					{{ fax }}
				</p>
			</span>
		</div>

		<app-icon
			(click)="copyToClipboard(fax || email)"
			[icon]="ICON.COPY"
			class="cursor-pointer"
		></app-icon>
	</div>
</ng-template>
